<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">Give Away Management</h4>
        </div>

    </div>
</div>

<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <div class="row">
                                <div class="col-md-11">
                                    <div id="zero_config_filter" class="dataTables_filter" (click)="filter()">
                                        <button style="background-color: #e0e09e"  >
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter</button>
                                    </div>
                                </div>

                                <div class="col-md-1">

                                    <div id="zero_config_filter" class="dataTables_filter" (click)="exportTable()">
                                        <button style="background-color: #e0e09e">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>

                                </div>
                            </div>
                            <div *ngIf="showFilter" style="background-color: #e0e09e;width: 895px;">
                                <div class="container-fluid" style="color: black">
                                    
                                    <input type="radio" id="emailId" name="gender" [(ngModel)]="filterValueSelected"
                                        value="ei" (change)="applyCustomizedFilter()" style="margin-top: 29px;"> Bidded Account Email Id&nbsp;&nbsp;
                                    <input type="radio" id="name" name="gender" [(ngModel)]="filterValueSelected"
                                        value="pn" (change)="applyCustomizedFilter()"> Prouct Name &nbsp;&nbsp;
                                   
                                  

                                </div>
                                <div style="margin-left: 820px">

                                    <button class="btn btn-dark" (click)="filter()">Cancel</button>

                                </div>
                            </div>
                            <div>
                                <div>
                                  
                                    <mat-form-field *ngIf="showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput [(ngModel)]="searchValue"
                                            (keyup)="applyCustomizedFilterSearch(searchValue)">

                                    </mat-form-field>
                                    <mat-form-field *ngIf="!showCustomisedSearch">
                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>


                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                        <ng-container matColumnDef="productId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Id
                                            </th>
                                            <td *matCellDef="let row">{{row.productId}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="productDetails.productName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name
                                            </th>
                                            <td *matCellDef="let row">{{row.productDetails.productName}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="productImage">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Image</th>
                                            <td *matCellDef="let row" style="white-space: nowrap;">
                                              
                                                <button class="dropdown-item" data-toggle="modal"
                                                data-target="#responsiveImages" style="color:rgb(30, 110, 124)" (click)="viewImages(row.productId)">
                                               View
                                                </button>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="accountDetails.emailAddress">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Id</th>
                                            <td *matCellDef="let row">{{row.accountDetails.emailAddress}}</td>
                                        </ng-container> 
                                        <ng-container matColumnDef="productDetails.stockQuantity">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Quantity</th>
                                            <td *matCellDef="let row">  {{row.productDetails.stockQuantity}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="productDetails.price">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>  Price</th>
                                            <td *matCellDef="let row"> {{row.productDetails.price}}</td>
                                        </ng-container>
                                                                           
                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25,100]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<!-- End Container fluid  -->
<div id="responsiveImages" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content" style="width:900px">
            <div class="modal-header">
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <img style="text-indent: -10000px"  src="{{myurl+'Misc/Images/productImages/'+productImageId+'_0'}}"
                width="100" height="100" />
                <img   style="text-indent: -10000px" src="{{myurl+'Misc/Images/productImages/'+productImageId+'_1'}}"
                width="100" height="100" />
                <img  style="text-indent: -10000px"  src="{{myurl+'Misc/Images/productImages/'+productImageId+'_2'}}"
                width="100" height="100" />
            </div>
        </div>
    </div>
</div>
